module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "justify-center": ""
    }
  }, [_c('v-card', [_c('v-data-table', {
    attrs: {
      "mobile-breakpoint": "0",
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loading,
      "no-data-text": _vm.noDataText,
      "items-per-page": 25,
      "footer-props": {
        'items-per-page-options': [10, 25, 100]
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('tr', {
          style: (_vm.rowStyle),
          on: {
            "click": function($event) {
              _vm.editItem(_vm.getEditId(props.item))
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatCategories(props.item, _vm.categoriesData)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatTags(props.item)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('v-chip', {
          attrs: {
            "small": "",
            "label": "",
            "color": _vm.combineModeChipColor(props.item),
            "text-color": "white"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.combineModeChipLabel(props.item)) + "\n                ")])], 1), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "1%",
            "padding": "0px",
            "white-space": "nowrap"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('span', {
          staticStyle: {
            "display": "inline-flex"
          }
        }, [(props.item.uuid) ? _c('v-btn', {
          attrs: {
            "title": "Copy Share URL",
            "icon": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.copyShareUrl(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("content_copy")])], 1) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('v-btn', {
          attrs: {
            "title": "Delete",
            "icon": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)])])]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "color": "blue",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this share?  This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteItem.apply(null, arguments)
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), (_vm.canCreate) ? _c('v-btn', {
    staticClass: "mt-4 py-6 px-6 rounded-lg",
    attrs: {
      "dark": "",
      "color": "green",
      "id": "addButton"
    },
    on: {
      "click": function($event) {
        return _vm.editItem('new')
      }
    }
  }, [_vm._v("\n        New Collection\n        "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b7988e3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 423
// module chunks = 1